export const removeLeadingSlash = <T extends string | undefined>(string: T) => {
  if (!string || !string.startsWith('/')) return string
  return string.slice(1)
}
